const InputRequired = () => {
    return(
        <i className={`material-icons opacity-10 ms-2 text-danger text-xxs`}>emergency</i>
    );
};

export default InputRequired;